import React from 'react';
import PropTypes from 'prop-types';
import { forgeClassHelper } from '../utils/classes';

const classes = forgeClassHelper('typeahead');

class SuggestionsAnnouncer extends React.PureComponent {
  render() {
    if (this.props.text) {
      return (
        <div className={classes({ element: 'suggestions-announcer' }).className} aria-live="polite">
          {this.props.text}
        </div>
      );
    } else {
      return null;
    }
  }
}

SuggestionsAnnouncer.propTypes = {
  text: PropTypes.string,
};

export default SuggestionsAnnouncer;
